import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

import { MasterService } from 'src/app/services/master.service';

import { AppConstants } from "../app_setting/app-constants";

@Injectable()
export class PopupMessageRegistrationNPWPResolver implements Resolve<any> {
  constructor(private masterService: MasterService) {}

  public resolve() {

    return this.masterService
      .getPopupMessageDetail(AppConstants.PopupMessageRegistrationNPWPCode)
      .toPromise()
      .then((result: any) => {
        return result.data || null;
      })
      .catch(error => {
        return null;
      });
  }
}
